/* eslint-disable */

import ActionCarousel from './actionCarousel/ActionCarousel'
import { useEffect, useState } from 'react'
import { Grid, Box, Typography, useTheme } from '@mui/material'
import { InvestedPlansSelector } from '../../store/InvestedPlansStore'
import {
  useRecoilRefresher_UNSTABLE,
  useSetRecoilState,
  useRecoilValue,
  useRecoilValueLoadable,
} from 'recoil'
import { useThemeMode } from '../../Provider/ThemeContextProvider'
import { toCurrency } from '../../utils/CurrencyUtil'
import { useLocation, useNavigate } from 'react-router-dom'
import { messageModalState } from '../../store/Feedback'
import { deleteReq, get } from '../../http/restservice'
import IconsSelector from '../../store/IconsStore'
import { EllipsisVertical } from 'lucide-react'
import { Separator } from '../../Components/ui/separator'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../Components/ui/alert-dialog'
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from '../../Components/ui/menubar'
import ActionNotification from './ActionNotification'
import env from '../../env/env'
import { capitalizeWords } from '../../utils/Util'
import { MFUserSubSeqBaskets } from '../../store/AdminStore'
import Loader from '../../Components/Loader/Loader'
import { useModal } from '../../hooks/use-modal-store'

const AddPlan = () => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const { darkMode } = useThemeMode()
  const [plans, setPlans] = useState()
  const [mergedPlans, setMergedPlans] = useState([])
  let actionPlanUser = sessionStorage.getItem('actionPlanUser')
  const clientCode = JSON.parse(actionPlanUser)?.data?.uid?.split('-')[0].toUpperCase()
  const refreshPlans = useRecoilRefresher_UNSTABLE(InvestedPlansSelector)
  const subOneTime = useRecoilValueLoadable(MFUserSubSeqBaskets(clientCode))
  const refrshSubOneTime = useRecoilRefresher_UNSTABLE(MFUserSubSeqBaskets(clientCode))
  const { onOpen } = useModal()
  const theme = useTheme()
  const [planToDelete, setPlanToDelete] = useState({})
  const iconsList = useRecoilValue(IconsSelector)
  const navigate = useNavigate()
  const location = useLocation()
  const [open, setOpen] = useState(false)

  const receivedData =
    location.state?.data || (actionPlanUser ? JSON.parse(actionPlanUser)?.data : null)

  const [mfData, setMFData] = useState([])

  const fetchAllPlans = async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getPlans`
    let customerId = receivedData?.id
    try {
      const response = await get(url, {}, { customerId })
      if (response?.response?.code === 400) {
        setPlans([])
        return
      }
      setPlans(response?.data)
    } catch (error) {
      console.log(error)
    }
  }

  const userMFBasket = async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getUserMFBaskets`
    let clientCode = receivedData?.uid?.split('-')[0]?.toUpperCase()
    try {
      const response = await get(url, {}, { clientCode })
      setMFData(response?.data?.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchAllPlans()
    userMFBasket()
  }, [])

  useEffect(() => {
    const mergePlansWithOneTimeOrders = (plans, oneTimeOrders) => {
      if (!Array.isArray(oneTimeOrders)) {
        console.error('Expected oneTimeOrders to be an array, got:', oneTimeOrders)
        return []
      }

      return oneTimeOrders
        ?.map((order) => {
          const matchedPlan = mfData?.find(
            (basket) => basket.customerBasketInvestmentId === order.customerBasketInvestmentId,
          )

          if (matchedPlan) {
            return {
              oneTimeOrder: order,
              ...matchedPlan,
            }
          }
        })
        .filter(Boolean)
    }

    const subSeqPlans = subOneTime?.state === 'hasValue' && JSON.parse(subOneTime?.contents?.data)
    const result = mergePlansWithOneTimeOrders(plans, subSeqPlans?.data)

    setMergedPlans(result)
  }, [subOneTime.state, plans, mfData])

  useEffect(() => {
    if (!plans || plans.length === 0 || !mfData || mfData.length === 0) return

    const basketMap = mfData?.reduce((acc, basket) => {
      acc[basket.customerBasketInvestmentId] = basket.basketStatus
      return acc
    }, {})

    const userPlans = plans?.map((plan) => {
      if (basketMap[plan?.customerMfBasketInvestmentId]) {
        return { ...plan, status: basketMap[plan?.customerMfBasketInvestmentId] }
      }
      return plan
    })

    const isSame = JSON.stringify(plans) === JSON.stringify(userPlans)

    if (!isSame) {
      setPlans(userPlans)
    }

    if (
      plans &&
      plans?.length > 0 &&
      mfData?.state === 'hasValue' &&
      mfData?.contents?.length == 0
    ) {
      console.log(plans)
      setPlans(plans)
    }
  }, [])

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false)
  }
  const setMessageModalState = useSetRecoilState(messageModalState)

  const viewEditPlan = (item, basket) => {
    if (item.planType === 'CHILDEDUCATION') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/educationplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    } else if (item.planType === 'RETIREMENT') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/retirementplan',
        {
          state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' },
        },
      )
    } else if (item.planType === 'MARRIAGE') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/weddingplan',
        {
          state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' },
        },
      )
    } else if (item.planType === 'PURCHASE') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/purchaseplan',
        {
          state: {
            SubOneTime: true,
            basket: basket,
            plans: item,
            edit: item.status === 'DRAFT',
          },
        },
      )
    } else if (item.planType === 'HOLIDAY') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/vacationplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    } else if (item.planType === 'EMERGENCY') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/emergencyplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    } else if (item.planType === 'HOME') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/homepurchaseplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    } else if (item.planType === 'VEHICLE') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/vehicleplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    } else if (item.planType === 'GENERALSAVING') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/generalsavingplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    } else if (item.planType === 'PASSION') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/passionplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    } else if (item.planType === 'JEWELLERY') {
      navigate(
        '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/jewelleryplan',
        { state: { SubOneTime: true, basket: basket, plans: item, edit: item.status === 'DRAFT' } },
      )
    }
  }

  const deletePlan = async (plan) => {
    try {
      const response = await deleteReq(`/planservice/api/plan/${plan.id}`)

      console.log('🚀 ~ deletePlan ~ response:', response)

      const url = `${env.API_URL}adminservice/api/actionPlan/deleteUserMFBasket/${plan.customerMfBasketInvestmentId}`
      let bdelete = await deleteReq(url)
      console.log('🚀 ~ deletePlan ~ bdelete:', bdelete)

      if (response.status === 204) {
        fetchAllPlans()
        refreshPlans()
        setMessageModalState({
          message: 'Plan deleted successfully',
          linkMessage: '',
          severity: 'info',
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const deleteSubsequentOneTime = async (plan) => {
    try {
      const url = `${env.API_URL}adminservice/api/actionPlan/removeSubsequentOneTimeOrder/${plan.id}`
      const response = await deleteReq(url)

      if (response.status === 200) {
        await fetchAllPlans()
        refrshSubOneTime()
        setMessageModalState({
          message: 'Subsequent One Time deleted successfully',
          linkMessage: '',
          severity: 'info',
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getStatus = (status) => {
    return status?.toUpperCase()
  }

  return (
    <>
      <>
        <div className='bg-white w-[320px] mx-auto md:w-[1128px] h-56 box-border rounded-3xl border mt-5'>
          <div className='mb-12 px-8'>
            <ActionCarousel receivedData={receivedData} plans={plans} mfData={mfData} />
          </div>

          <div className='flex justify-between my-3'>
            <p className='underline cursor-pointer' onClick={() => setOpen(true)}>
              Send notification
            </p>
          </div>

          <div className='my-5 bg-white md:rounded-3xl'>
            <div className='flex flex-col justify-between md:mb-1 md:mt-0 '>
              <h1
                className='text-xl md:text-2xl font-semibold'
                style={{ letterSpacing: '-0.096px', marginBottom: '10px' }}
              >
                User Subsequent Plans
              </h1>
            </div>

            <div className={`justify-center lg:justify-start flex gap-x-3`}>
              <div className={`lg:grid-cols-3 grid grid-cols-1 md:grid-cols-2 gap-6`}>
                {subOneTime?.state === 'loading' && (
                  <div className='py-6'>
                    <Loader />
                    Loading User Subsequent Plans...
                  </div>
                )}

                {subOneTime?.state === 'hasValue' &&
                  JSON.parse(subOneTime?.contents?.data)?.message?.includes(
                    'No subsequent one time orders found for the user.',
                  ) && (
                    <p className='py-6 text-xl text-black-400'>
                      {JSON.parse(subOneTime?.contents?.data)?.message}
                    </p>
                  )}

                {mergedPlans?.length > 0 &&
                  mergedPlans?.map((item, index) => {
                    return (
                      <Box
                        key={`investedPlans-${index}`}
                        sx={{
                          stroke: '#D3DBEC',
                          borderRadius: '24px',
                          border: theme.palette.border.primary,
                          fontWeight: '500',
                          background: theme.palette.secondary.main,
                          padding: '24px',
                          transition: 'box-shadow',
                          '&:hover': {
                            boxShadow: '0px 6px 24px 0px rgba(65, 85, 141, 0.12)',
                          },
                        }}
                      >
                        <Box className='flex justify-between'>
                          <div
                            className='w-full'
                            // onClick={() => {
                            //   viewEditPlan(item)
                            // }}
                          >
                            <Box className='flex gap-x-3 items-center'>
                              <div className='h-16 w-16 rounded-full'>
                                <img className='rounded-md w-16' src={`${env.SVGS}/basket.svg`} />
                              </div>

                              <Typography
                                component='label'
                                sx={{
                                  fontSize: '20px',
                                  fontWeight: 600,
                                  letterSpacing: '-0.8px',
                                }}
                                className={`${'cursor-pointer'}`}
                              >
                                {item.customerBasketName}
                                {/* {item.createdSource === 'ACTION PLAN' && (
                                  <div className='text-xs p-2 flex justify-center items-center text-green-500 rounded-full bg-green-100'>
                                    Admin Created
                                  </div>
                                )} */}
                              </Typography>
                            </Box>

                            <Separator className='my-6' />
                          </div>

                          <Menubar>
                            <MenubarMenu className='bg-transparent'>
                              <MenubarTrigger className=' p-1 h-6 w-6 rounded-full hover:bg-[#D3DBEC]'>
                                <EllipsisVertical
                                  fill='#5D5D5D'
                                  className='cursor-pointer hover:text-primary-500'
                                />
                              </MenubarTrigger>

                              <MenubarContent className='rounded-[10px] flex flex-col gap-y-1'>
                                <MenubarItem
                                  onClick={() => {
                                    deleteSubsequentOneTime(item?.oneTimeOrder)
                                  }}
                                  className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                >
                                  Delete
                                </MenubarItem>
                              </MenubarContent>
                            </MenubarMenu>
                          </Menubar>
                        </Box>

                        {item?.oneTimeOrder?.orderInvestmentAmount && (
                          <div>
                            <p className='text-black-400'>One-Time</p>
                            <p className='text-sm flex gap-x-2 items-center'>
                              <span>
                                &#8377;
                                {toCurrency(item?.oneTimeOrder?.orderInvestmentAmount)}
                              </span>

                              <span
                                className='text-primary-500 cursor-pointer'
                                onClick={() => {
                                  onOpen('OpenAdminMFBreakdown', {
                                    constituents:
                                      item?.oneTimeOrder?.orderInvestmentBreakdown?.filter(
                                        (item) => item.weightage > 0,
                                      ),
                                    amount: item?.oneTimeOrder?.orderInvestmentAmount,
                                  })
                                }}
                              >
                                View Breakdown
                              </span>
                            </p>
                          </div>
                        )}

                        {item?.oneTimeOrder?.sipOrderInvestmentAmount && (
                          <div>
                            <p className='text-black-400'>SIP</p>
                            <p className='text-sm flex gap-x-2 items-center'>
                              <span>
                                &#8377;
                                {toCurrency(item?.oneTimeOrder?.sipOrderInvestmentAmount)}
                              </span>

                              <span
                                className='text-primary-500 cursor-pointer'
                                onClick={() => {
                                  onOpen('OpenAdminMFBreakdown', {
                                    constituents:
                                      item?.oneTimeOrder?.sipOrderInvestmentBreakdown?.filter(
                                        (item) => item.weightage > 0,
                                      ),
                                    amount: item?.oneTimeOrder?.sipOrderInvestmentAmount,
                                  })
                                }}
                              >
                                View Breakdown
                              </span>
                            </p>
                          </div>
                        )}
                      </Box>
                    )
                  })}
              </div>
            </div>
          </div>

          <div className='my-5 bg-white md:rounded-3xl'>
            <div
              className='flex flex-col justify-between md:mb-1 md:mt-0 '
              // style={{ paddingBottom: '0px', paddingLeft: '40px' }}
            >
              <h1
                className='text-xl md:text-2xl font-semibold'
                style={{ letterSpacing: '-0.096px', marginBottom: '10px' }}
              >
                User All Plans
              </h1>
            </div>

            <div className={`justify-center lg:justify-start flex gap-x-3`}>
              <div className={`lg:grid-cols-3 grid grid-cols-1 md:grid-cols-2 gap-6`}>
                {plans &&
                  plans.length > 0 &&
                  plans.map((item, index) => {
                    const basket = mfData?.find(
                      (b) => b.customerBasketInvestmentId === item.customerMfBasketInvestmentId,
                    )

                    const table1 = item.results.table
                    let totalInvestementPlanned = 0
                    let totalExpenses = 0
                    let totalPlannedContribution = 0
                    // eslint-disable-next-line no-unused-vars
                    Object.entries(table1).forEach(([key, value]) => {
                      totalExpenses += value.projectedExpenses
                      totalPlannedContribution += value.plannedContribution
                    })

                    if (item.planType === 'RETIREMENT') {
                      totalExpenses = table1['1'].corpus
                    }
                    if (item.planType === 'HOLIDAY' || item.planType === 'CHILDEDUCATION') {
                      totalInvestementPlanned = totalExpenses - totalPlannedContribution
                    } else {
                      totalInvestementPlanned = totalExpenses - (table1['1'].fvOfCurrentValue || 0)
                    }
                    if (totalInvestementPlanned <= 0) {
                      totalInvestementPlanned = 0
                    }

                    // const mFStatus = (item) => {
                    //   return mfData?.find((status) => status.customerBasketInvestmentId === item)
                    // }

                    return (
                      <Box
                        key={`investedPlans-${index}`}
                        sx={{
                          stroke: '#D3DBEC',
                          borderRadius: '24px',
                          border: theme.palette.border.primary,
                          fontWeight: '500',
                          background: theme.palette.secondary.main,
                          padding: '24px',
                          transition: 'box-shadow',
                          '&:hover': {
                            boxShadow: '0px 6px 24px 0px rgba(65, 85, 141, 0.12)',
                          },
                        }}
                      >
                        <Box className='flex justify-between'>
                          <div
                            className='w-full'
                            // onClick={() => {
                            //   viewEditPlan(item)
                            // }}
                          >
                            <Box className='flex gap-x-3 items-center'>
                              <div className='h-16 w-16 rounded-full'>
                                <img
                                  className='rounded-md w-16'
                                  src={
                                    darkMode
                                      ? iconsList['dark' + item.planType]
                                      : iconsList['light' + item.planType]
                                  }
                                />
                              </div>

                              <div>
                                <h2 className='text-black-500 text-xl font-semibold'>
                                  {' '}
                                  {item.planName}
                                </h2>

                                <p className='flex gap-x-2'>
                                  {item.createdSource === 'ACTION PLAN' && (
                                    <span className='px-2 rounded-full bg-secondary-100 border-secondary-500 flex-1 text-nowrap'>
                                      Admin Created
                                    </span>
                                  )}

                                  {basket?.hasOwnProperty('customerBasketInvestmentId') && (
                                    <span className='bg-secondary-100 rounded-full px-2'>
                                      Basket
                                    </span>
                                  )}
                                </p>
                              </div>
                            </Box>

                            <Separator className='my-6' />
                          </div>

                          <Menubar>
                            <MenubarMenu className='bg-transparent'>
                              <MenubarTrigger className=' p-1 h-6 w-6 rounded-full hover:bg-[#D3DBEC]'>
                                <EllipsisVertical
                                  fill='#5D5D5D'
                                  className='cursor-pointer hover:text-primary-500'
                                />
                              </MenubarTrigger>

                              <MenubarContent className='rounded-[10px] flex flex-col gap-y-1'>
                                {/* <MenubarItem
                                    onClick={() => {
                                      viewEditPlan(item)
                                    }}
                                    className='py-2 pl-3 text-sm text-black-500 cursor-pointer  hover:bg-blue-100'
                                  >
                                    View Details
                                  </MenubarItem> */}
                                {basket?.basketStatus !== 'DRAFT' &&
                                  basket?.hasOwnProperty('customerBasketInvestmentId') && (
                                    <MenubarItem
                                      onClick={() => {
                                        viewEditPlan(item, basket)
                                      }}
                                      className='py-2 pl-3 text-sm text-black-500 cursor-pointer hover:bg-blue-100 '
                                    >
                                      Subsequent One Time
                                    </MenubarItem>
                                  )}

                                {basket?.basketStatus === 'DRAFT' && (
                                  <MenubarItem
                                    onClick={() => {
                                      setPlanToDelete(item)
                                      setOpenDeleteDialog(true)
                                    }}
                                    className='py-2 pl-3 text-sm cursor-pointer hover:bg-red-100 hover:text-red-500'
                                  >
                                    Delete
                                  </MenubarItem>
                                )}
                              </MenubarContent>
                            </MenubarMenu>
                          </Menubar>
                        </Box>

                        <Grid
                          container
                          rowGap={4}
                          // onClick={() => {
                          //   viewEditPlan(item)
                          // }}
                          sx={{ cursor: 'pointer' }}
                        >
                          <Grid item xs={6} md={6}>
                            <Typography
                              component='label'
                              sx={{ color: '#727272', fontSize: '14px' }}
                            >
                              Monthly SIP
                            </Typography>
                            <Typography
                              component='div'
                              fontWeight={600}
                              style={{ color: '#2D2D2D' }}
                            >
                              <Typography component='span' className='custom-font'>
                                &#8377;
                              </Typography>
                              {toCurrency(item.monthlySIP)}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography
                              component='label'
                              sx={{ color: '#727272', fontSize: '14px' }}
                            >
                              Goal Amount
                            </Typography>
                            <Typography
                              component='div'
                              fontWeight={600}
                              style={{ color: '#2D2D2D' }}
                            >
                              <Typography component='span' className='custom-font'>
                                &#8377;
                              </Typography>
                              {toCurrency(totalInvestementPlanned)}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography
                              component='label'
                              sx={{ color: '#727272', fontSize: '14px' }}
                            >
                              Goal Year
                            </Typography>
                            <Typography
                              component='div'
                              fontWeight={600}
                              style={{ color: '#2D2D2D' }}
                            >
                              {item.results.targetYear}
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            xs={6}
                            md={6}
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'start',
                              alignItems: 'start',
                            }}
                          >
                            <Typography
                              component='label'
                              sx={{ color: '#727272', fontSize: '14px' }}
                              fontWeight={600}
                            >
                              Status
                            </Typography>
                            <Typography
                              component='p'
                              sx={{
                                display: 'inline-block',
                                borderRadius: '24px',
                                color:
                                  getStatus(
                                    basket?.basketStatus ? basket?.basketStatus : item?.status,
                                  ) === 'INVESTED'
                                    ? '#5B8350'
                                    : getStatus(
                                        basket?.basketStatus ? basket?.basketStatus : item?.status,
                                      ) === 'PARTIALLY_INVESTED'
                                    ? '#74A766'
                                    : '#D99E16',
                                fontWeight: '600',
                              }}
                            >
                              {capitalizeWords(
                                getStatus(
                                  basket?.basketStatus ? basket?.basketStatus : item?.status,
                                ),
                              )}
                            </Typography>
                          </Grid>

                          <Grid item xs={6} md={6}>
                            <Typography
                              component='label'
                              sx={{ color: '#727272', fontSize: '14px' }}
                            >
                              One Time Investment
                            </Typography>
                            <Typography
                              component='div'
                              fontWeight={600}
                              style={{ color: '#2D2D2D' }}
                            >
                              <Typography component='span' className='custom-font'>
                                &#8377;
                              </Typography>{' '}
                              {item?.lumpsum ? item?.lumpsum : 0}
                            </Typography>
                          </Grid>

                          {/* 
                          <Grid item xs={6} md={6}>
                            <p className='text-sm flex gap-x-2 items-center'>
                              <span
                                className='text-primary-500 cursor-pointer'
                                onClick={() => {
                                  onOpen('OpenAdminMFBreakdown', {
                                    constituents: item?.orderInvestmentBreakdown?.filter(
                                      (item) => item.weightage > 0,
                                    ),
                                    amount: item?.orderInvestmentAmount,
                                  })
                                }}
                              >
                                View Breakdown
                              </span>
                            </p>
                          </Grid> */}
                        </Grid>
                      </Box>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>

        <AlertDialog open={openDeleteDialog} onOpenChange={handleDeleteDialogClose}>
          <AlertDialogContent className='py-16'>
            <AlertDialogHeader>
              <AlertDialogTitle className='text-black-500 font-DMSans font-semibold'>
                Are you absolutely sure?
              </AlertDialogTitle>
              <AlertDialogDescription className='text-black-400 font-DMSans'>
                Do you want to delete this {planToDelete.planName} ?
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel
                onClick={() => {
                  handleDeleteDialogClose()
                }}
              >
                No
              </AlertDialogCancel>
              <AlertDialogAction
                onClick={() => {
                  deletePlan(planToDelete)
                  setPlanToDelete({})
                  setOpenDeleteDialog(false)
                }}
              >
                Yes
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </>

      {open && <ActionNotification open={open} setOpen={setOpen} data={receivedData} />}
    </>
  )
}

export default AddPlan
